"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeFilterAbsolute = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Clear_1 = tslib_1.__importDefault(require("@mui/icons-material/Clear"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const IconButton_1 = tslib_1.__importDefault(require("@mui/material/IconButton"));
const InputAdornment_1 = tslib_1.__importDefault(require("@mui/material/InputAdornment"));
const DateCalendar_1 = require("@mui/x-date-pickers/DateCalendar");
const DateTimeField_1 = require("@mui/x-date-pickers/DateTimeField");
const DigitalClock_1 = require("@mui/x-date-pickers/DigitalClock");
const DateTimeFilterAbsolute = (props) => {
    const { value, onChange, onClear, errorText, DateCalendarProps, DigitalClockProps, CalendarClockContainerProps, DateTimeFieldProps, } = props;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(DateTimeField_1.DateTimeField, { fullWidth: true, value: value, helperText: errorText ? errorText : DateTimeFieldProps?.helperText, FormHelperTextProps: errorText
                ? { sx: { color: (theme) => theme.palette.error.main }, ...DateTimeFieldProps?.FormHelperTextProps }
                : DateTimeFieldProps?.FormHelperTextProps, InputProps: {
                error: Boolean(errorText),
                ...(value && {
                    // Replace with clearable when upgrading to latest version of @mui/x-date-pickers ARGUS-47745
                    endAdornment: (react_1.default.createElement(InputAdornment_1.default, { position: "end", sx: { pr: 1 } },
                        react_1.default.createElement(IconButton_1.default, { onClick: (e) => onClear(e), size: "small" },
                            react_1.default.createElement(Clear_1.default, { fontSize: "small" })))),
                }),
            }, onChange: (v, c) => (c?.validationError ? null : onChange(v)), ...DateTimeFieldProps }),
        react_1.default.createElement(Box_1.default, { sx: { display: "flex", flexDirection: "row", gap: 1, mt: 1, maxHeight: "17.75rem" }, ...CalendarClockContainerProps },
            react_1.default.createElement(DateCalendar_1.DateCalendar, { value: value, onChange: (v) => onChange(v), ...DateCalendarProps }),
            react_1.default.createElement(DigitalClock_1.DigitalClock, { value: value, onChange: (v) => onChange(v), sx: { width: "7.5rem", mt: 1, maxHeight: "unset" }, ...DigitalClockProps }))));
};
exports.DateTimeFilterAbsolute = DateTimeFilterAbsolute;
exports.default = exports.DateTimeFilterAbsolute;
